<div class="card">
	<div class="card-header">
		<h2>Inventario Aleatorio 
			<i tooltip="Ver prioridades" (click)="modalPriorities = true" [appCheckPermission]="[5045]" [permissionType]="permissionType.CREATE"
			class="fa-solid fa-layer-group text-info clickeable"></i></h2>
	</div>
	<div class="card-body">
		<div class="row">
			<div class="col">
				<div class="form-group">
					<label for="warehouse" class="form-label">Bodega</label>
					<div class="input-group">
						<span class="input-group-text info" tooltip="Bodegas faltantes">
							<div class="superposition-parent">
								<i class="fa fa-warehouse"></i>
								<i class="fa fa-question superposition-icon"></i>
							</div>
							<span class="info-value">{{missing}}</span>
						</span>
						<app-input-autocomplete (changeStatus)="selectWarehouse($event.filterElement)"
							(inputMethod)="searchWarehouse()" [allBorderRadius]="false" [filterElements]="warehouses"
							[placeholder]="'Ingresa una bodega'" [custom]="true" [inputs]="filterWarehouse">
							<ng-template #itemsTemplate let-filter>
								<!-- This is the content that will be projected -->
								<div items>
									<h5 class="text-info" style="line-height: normal; margin-bottom: 0;">
										{{filter.name}}</h5>
									<span class="text-muted" style="color: white !important;">{{filter.code}} -
										NIT:
										<ng-container *ngIf="filter.nit">
											<b>{{filter.nit}}</b>
										</ng-container>
										<ng-container *ngIf="!filter.nit">
											<span style="color: gray;">
												<i class="fa fa-circle-info"></i>No cuenta con NIT
											</span>
										</ng-container>
									</span>
								</div>
							</ng-template>
						</app-input-autocomplete>
					</div>
				</div>
			</div>
		</div>
		<div class="container-radio">
			<input id="list" [(ngModel)]="view" hidden type="radio" class="radio-input" [value]="1" name="view">
			<label for="list" class="radio"><i class="fa fa-list radio-icon"></i></label>
			<input hidden id="table" [(ngModel)]="view" type="radio" class="radio-input" [value]="0" name="view">
			<label for="table" class="radio"><i class="fa fa-table-cells radio-icon"></i></label>
		</div>
		<!-- <div class="row" *ngFor="let product of products">
			<div class="col-sm-2">
				<img src="" alt="">
			</div>
			<div class="col-sm-6">
				<h3>{{product.product.name}}</h3>
				<div class="row">
					<div class="col">
						<p>
							<i class="fa fa-box"></i>
							{{product.product.code}}
						</p>
					</div>
					<div class="col">
						<p>
							<i class="fa fa-barcode"></i>
							<ng-container *ngIf="product.product.barCode">
								{{product.product.barCode}}
							</ng-container>
							<ng-container *ngIf="!product.product.barCode">
								<span class="text-muted">
									No tiene <i class="fa fa-circle-info"></i>
								</span>
							</ng-container>
						</p>
					</div>
				</div>
			</div>
			<div class="col-sm-4">

			</div>
			<hr>
		</div> -->
		<div class="grid" style="margin-top: 1em;" [hidden]="view==1">
			<div class="card card-with-icon" [ngClass]="product.addingComment ?'span-2':''"
				*ngFor="let product of products">
				<div class="icon-comment" *ngIf="product.comments">
					<i class="fa fa-comment-dots"></i>
				</div>
				<div class="icon-waiting" *ngIf="(product.units === 0 && !product.confirmZero) 
				|| product.units === null || product.units === undefined">
					<i class="fa fa-circle"></i>
				</div>
				<div class="image-product" *ngIf="product.product.image">
					<img style="height: 100%;"
						[src]="'https://s3.amazonaws.com/rrhh-images/erp/products/'+product.product.image+''" alt="">
				</div>
				<div class="row">
					<div class="col">
						<div class="card-header" style="margin-bottom: 0 !important;">
							<div class="row">
								<div class="col-sm-10">
									<h5>{{product.product.name}}
										<i [ngClass]="product.addingComment ? 'fa-comment-slash': product.comments ? 'fa-comment-dots' : 'fa-comment-medical' "
											(click)="product.addingComment = !product.addingComment;"
											[tooltip]="product.addingComment ? 'Ocultar comentario': product.comments ? 'Editar comentario' : 'Agregar comentario'"
											class="fa-solid clickeable text-info"></i>
									</h5>
								</div>
								<div class="col-sm-2">
									<img style="max-height: 100%;"
										[src]="'https://s3.amazonaws.com/rrhh-images/erp/products/'+ product.product.image"
										alt="">
								</div>
							</div>
						</div>
						<div class="card-body">
							<div class="row">
								<div class="col">
									<div class="field">
										<span
											class="val-span">{{product.product.barCode?product.product.barCode:'---'}}</span>
										<span class="field-span">
											<i class="fa fa-barcode"></i> Código de barras
										</span>
									</div>
								</div>
								<div class="col">
									<div class="field">
										<span class="val-span">{{product.product.code}}</span>
										<span class="field-span">
											<i class="fa fa-box"></i> Código
										</span>
									</div>
								</div>
								<div class="col">
									<div class="field">
										<div class="input-group">
											<button tooltip="Confirmar cero existencias" placement="left"
												*ngIf="product.units===0 && !product.confirmZero && !counted"
												(click)="product.confirmZero = true"
												class="btn btn-success container-confirm">
												<i class="fa fa-0"></i>
												<i class="fa fa-circle-check confirm"></i>
											</button>
											<input type="number" [disabled]="counted || product.counted"
												(change)="product.units = product.units < 0? 0: product.units;"
												placeholder="--" [ngClass]="(product.units===0 && !product.confirmZero) 
												|| product.units === null || product.units === undefined ? 'missing':''" [(ngModel)]="product.units"
												class="form-control">
										</div>
										<span class="field-span">
											<i class="fa fa-boxes"></i> Unidades
										</span>
									</div>
								</div>
							</div>
							<div class="text-end mt-3" *ngIf="!counted">
								<button
									type="button"
									class="btn btn-success"
									*ngIf="!product.counted && !counted"
									[disabled]="
										product.counted ||
										savingIndividual[product.id] ||
										product.units === undefined ||
										product.units === null ||
										(product.units === 0 && !product.confirmZero)
									"
									(click)="saveCountIndividual(product)">

									<ng-container *ngIf="!savingIndividual[product.id]">
										<i
											class="fa fa-save">
										</i>

										Guardar
									</ng-container>

									<ng-container *ngIf="savingIndividual[product.id]">
										<i class="fa fa-spinner fa-spin"></i>
										Guardando...
									</ng-container>

								</button>

								<span
									*ngIf="product.counted"
									class="text-success ms-2">

									<i class="fa fa-circle-check"></i>
									Guardado

								</span>

							</div>
						</div>
					</div>
					<div *ngIf="product.addingComment" class="col"
						style="justify-content: center; flex-direction: column; display: flex; ">
						<div class="field">
							<textarea name="comment" [disabled]="counted || product.counted" placeholder="Ingresa un comentario"
								[(ngModel)]="product.comments" id="comment" class="form-control"></textarea>
							<span class="field-span">
								<i class="fa fa-comment"></i> Comentario
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="table-responsive" style="margin-top: 1em;" [hidden]="view==0">
			<table class="table table-bordered">
				<thead>
					<tr class="tr-middle">
						<th>
							Código de Barras
						</th>
						<th>
							Código de Producto
						</th>
						<th>
							Nombre
						</th>
						<th>
							Unidades
						</th>
						<th>
							Comentarios
						</th>
						<th>
							Acción
						</th>
					</tr>
				</thead>
				<tbody>
					<ng-container *ngIf="!loadingProducts">
						<tr class="tr-middle" *ngFor="let product of products">
							<td>
								<ng-container *ngIf="product.product.barCode">
									{{product.product.barCode}}
								</ng-container>
								<ng-container *ngIf="!product.product.barCode">
									<span class="text-muted">
										<i class="fa fa-circle-info"></i> No tiene
									</span>
								</ng-container>
							</td>
							<td>
								{{product.product.code}}
							</td>
							<td>
								{{product.product.name}}
							</td>
							<td>
								<div class="field">
									<div class="input-group">
										<button tooltip="Confirmar cero existencias" placement="left"
											*ngIf="product.units===0 && !product.confirmZero && !counted"
											(click)="product.confirmZero = true"
											class="btn btn-success container-confirm">
											<i class="fa fa-0"></i>
											<i class="fa fa-circle-check confirm"></i>
										</button>
										<input type="number" [disabled]="counted"
											(change)="product.units = product.units < 0? 0: product.units;"
											placeholder="--" [ngClass]="(product.units===0 && !product.confirmZero) 
											|| product.units === null || product.units === undefined ? 'missing':''" [(ngModel)]="product.units"
											class="form-control"
											[disabled]="counted || product.counted"
											>
									</div>
									<span class="field-span">
										<i class="fa fa-boxes"></i> Unidades
									</span>
								</div>
							</td>
							<td>
								<textarea name="comments" [disabled]="counted || product.counted" [(ngModel)]="product.comments" id="comments"
									class="form-control"></textarea>
							</td>
							<td>
								<button
									*ngIf="!product.counted && !counted"
									type="button"
									class="btn btn-success"
									tooltip="Guardar conteo"
									[disabled]="
										savingIndividual[product.id] ||
										product.units === undefined ||
										product.units === null ||
										(product.units === 0 && !product.confirmZero)
									"
									(click)="saveCountIndividual(product)">

									<ng-container *ngIf="!savingIndividual[product.id]">
										<i class="fa fa-save"></i>
									</ng-container>

									<ng-container *ngIf="savingIndividual[product.id]">
										<i class="fa fa-spinner fa-spin"></i>
									</ng-container>

								</button>

								<span
									*ngIf="product.counted"
									class="text-success">

									<i class="fa fa-circle-check"></i>
									Guardado

								</span>

							</td>
						</tr>
					</ng-container>
					<tr class="tr-middle" *ngIf="loadingProducts">
						<td colspan="6">
							<app-loading-animation [height]="'5rem'"></app-loading-animation>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<br>
		<app-loading-button [disabled]="getDisabledSave()" *ngIf="!counted" [object]="buttonSave"
			(clicked)="saveCount()"></app-loading-button>
	</div>
</div>
<app-modal-priority-inventory *ngIf="modalPriorities" (close)="modalPriorities = false"></app-modal-priority-inventory>